import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService, ConfigStateService, ReplaceableComponentsService, RoutesService } from '@abp/ng.core';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { NavItemsService } from '@abp/ng.theme.shared';
import { Router } from '@angular/router';
import { NhNavItemsComponent } from './nh-nav-items/nh-nav-items.component';
import { eThemeLeptonComponents } from '@volo/abp.ng.theme.lepton';
import { NhLogoComponent } from './nh-nav-items/nh-logo.component';
import { EnvService } from '../environments/env.service';
import { NhFooterComponent } from './nh-footer/nh-footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  
  subscriptions: Subscription[] = []
  currentUser$ = this.configStateService.getOne$('currentUser');
  callExpireWaringVisible : boolean;
  showHideSpinner: boolean = false;

  constructor(
    private ngbconfig: NgbDatepickerConfig, private authService: AuthService,
    private configStateService: ConfigStateService,private router: Router,
    private routes: RoutesService, private oAuthService: OAuthService,
    private navItems: NavItemsService,
    private replaceableComponents: ReplaceableComponentsService, 
    private envService: EnvService) {
       
    this.currentUser$.subscribe(user => {
      if (!user.isAuthenticated) {
        this.authService.navigateToLogin();
      }
    });


  }

  ngOnInit() {
    this.clearLocalStorageOnLogout();
    this.routes.remove(['administration']);

    this.replaceableComponents.add({
      component: NhLogoComponent,
      key: eThemeLeptonComponents.Logo,
    });

    this.replaceableComponents.add({
      component: NhNavItemsComponent,
      key: eThemeLeptonComponents.NavItems
    });

    this.subscriptions.push(this.envService.showHideSpinnerServiceObs.subscribe((res) => {
      this.showHideSpinner = res;
    }));

    this.replaceableComponents.add({
      component: NhFooterComponent,
      key: eThemeLeptonComponents.ApplicationLayoutFooter
    });
    
  }

  ngAfterViewInit() {
    this.showHideSpinner = false;
    this.envService.hideSpinner();
  }

  clearLocalStorageOnLogout() {
    let logoutSubscriptin = this.oAuthService.events
      .pipe(
        tap(console.warn),
        filter(event => event?.type === 'logout'),
      )
      .subscribe(event => {
        // logout event fired
        //this.customerCareService.updateCallEndTime();
        //this.customerCareService.clearCallLocalStorage();    
      });

      this.subscriptions.push(logoutSubscriptin);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    
  }
}
